import LockDesignerAdminTool from 'Vue/containers/LockDesignerAdminTool.vue';
import { createApp } from "vue";
import  { LockDesignerAdminToolStore } from 'Store/lockDesignerAdminToolStore';
import Toast, { PluginOptions } from 'vue-toastification';

namespace BHW.lockDesignerAdminTool {
    /**
     * Instantiate Vue Application
     */
    let initLockDesignerApp = function () {
        const options: PluginOptions = {
            transition: "Vue-Toastification__bounce",
            maxToasts: 20,
            newestOnTop: true
        };

        const ld = createApp(LockDesignerAdminTool);
        ld.use(LockDesignerAdminToolStore);
        ld.use(Toast, options);
        ld.mount("#lockDesignerAdminTool");

        // Check if web forms exists
        let form = document.getElementById('aspnetForm');

        if (form) {
            // Disable form submit event of admin page, which is using Web Forms
            form.addEventListener('submit',
                (event) => {
                    event.preventDefault();
                    return false;
                });
        }
    }

    export const init = () => {
        initLockDesignerApp();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    BHW.lockDesignerAdminTool.init();
});

